import axios from 'axios';
function obtenerCursos() {
  return axios.get("/obtener_cursos")
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function crearCurso(curso) {
  try {
    const response = axios.post('/crear_curso', curso, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response;
  } catch (error) {
    return { status: 'fail', error };
  }
}
function actualizarCurso(curso) {
  return axios.post("/actualizar_curso", curso)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function estadoCurso(curso) {
  return axios.post("/estado_curso", curso)
    .then((response) => {
      if (response.data) {
        return response.data;
      } else {
        throw new Error(response.data.status);
      }
    })
    .catch((error) => {
      throw error;
    });
}
function eliminarCurso(cursoId) {
  return axios.post("/eliminar_curso", { id: cursoId })
    .then((response) => {
      if (response.data && response.data.status === "success") {
        return response.data;
      } else {
        throw new Error(response.data.message || "Error desconocido");
      }
    })
    .catch((error) => {
      console.error("Error eliminando curso:", error);
      throw error;
    });
}
export {obtenerCursos, crearCurso, actualizarCurso, estadoCurso, eliminarCurso};
